export const CloserAvailabilityHistoryScreenPath =
  "/closers/check-closers-availability/history";
